import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  schema?: string;
  schemas?: string[];
  canonical?: string;
}

const SCHEMA_SCRIPT_ID_PREFIX = 'seo-ld-json';

const Seo: React.FC<SeoProps> = ({ title, description, keywords, schema, schemas, canonical }) => {
  useEffect(() => {
    document.title = title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', keywords);
    }
  }, [title, description, keywords]);

  useEffect(() => {
    if (!canonical) return;

    let canonicalTag = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute('href', canonical);
  }, [canonical]);

  useEffect(() => {
    const allSchemas = [...(schema ? [schema] : []), ...(schemas || [])];

    document.querySelectorAll(`script[id^="${SCHEMA_SCRIPT_ID_PREFIX}-"]`).forEach((el) => el.remove());

    const added: HTMLScriptElement[] = [];
    allSchemas.forEach((s, index) => {
      if (!s || !s.trim()) return;
      try {
        JSON.parse(s);
      } catch {
        return;
      }

      const script = document.createElement('script');
      script.id = `${SCHEMA_SCRIPT_ID_PREFIX}-${index}`;
      script.type = 'application/ld+json';
      script.text = s;
      document.head.appendChild(script);
      added.push(script);
    });

    return () => {
      added.forEach((script) => script.remove());
    };
  }, [schema, schemas]);

  return null;
};

export default Seo;
